module.exports = __webpack_public_path__ + "static/media/des-escolares.f3934e01.png";